import { Inject, Pipe, PipeTransform } from '@angular/core';
import { L10n, L10nBase } from '@skylab-angular-shared/core';

@Pipe({ name: 'translate' })
export class TranslatePipe implements PipeTransform {
    public constructor(@Inject(L10n) private l10n: L10nBase) {}

    public transform(value: string, params?: {[param: string]: unknown}): string {
        return this.l10n._T(value, params);
    }
}
